import axios from "axios";

import { errorTypeHandler } from "../utils/ErrorTypes";
import { checkInternetConnection } from "./QueryMethod";
export const postQueryHandler = (
  URL,
  data,
  isRequestProcessing,
  errorHandler,
  dataHandler,
  showSuccessMessage = true,
  isResetButtonClicked,
  errorDataHandler,
  token,
  LogoutFunc
) => {
  isRequestProcessing(true);
  axios({
    method: 'POST',
    url: URL,
    data: data,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${token}`,
    },
    timeout: 60000,
    withCredentials: true
  })
    .then((response) => {
        let headers_data = response.headers;
      const { error_code, error_description, data,ErrorCode,ErrorDesc } = response.data;
      if (parseInt(error_code) === 0) {
        if (showSuccessMessage) {
          errorHandler({
            error_code:0,
            message: "Successfully saved.",
            severity: "success",
          });
        } 
        dataHandler(response.data,isResetButtonClicked);
      } else if (response.data && !data) {
        if(error_code ){
          errorHandler({
            error_code: error_code,
            message: error_description,
            severity: "warning",
          });
        }
        // response does not have a data key into the response
        if (dataHandler) {
          dataHandler({
            data:response.data,
            totalCallCount:headers_data["x-count"]
        },isResetButtonClicked
            );
        }
      } else if(ErrorCode){
        errorHandler({
          error_code: ErrorCode,
          message: ErrorDesc,
          severity: "warning",
        });
      }
      else {
        errorHandler({
          error_code: error_code,
          message: error_description,
          severity: "warning",
        });
      }
      isRequestProcessing(false);
    })
    .catch((error) => {
      if(error?.response?.status==401 || error?.response?.status==403){
       console.log("Session-Manger-Session-Timeout");
       LogoutFunc()
      }
        

      isRequestProcessing(false);
      errorDataHandler()
      // After checking the internet connection ,checking the other error
      checkInternetConnection()
        .then((res) => {
          // Handling the Timeout Error
          if (error.message.includes("timeout")) {
            const { error_description, error_code } =
              errorTypeHandler("timeout");
            errorHandler({
              error_code: error_code,

              message: error_description,
              severity: "warning",
            });
            return;
          }
          if (error.response) {
            // error handling related to the client request
            // The request was made and the server responded with a status code
            const { error_description, error_code } = errorTypeHandler(
              error.response.status
            );

            errorHandler({
              error_code: error_code,

              message: error_description,
              severity: "warning",
            });
            return;
          } else if (error.request) {
            // error handling related to the server response
            // The request was made but no response was received
            const { error_description, error_code } =
              errorTypeHandler("NO_RESPONSE");

            errorHandler({
              error_code: error_code,

              message: error_description,
              severity: "warning",
            });
            return;
          } else {
            // All the Network Error
            console.log("error.config", error.config);
          }
        })
        .catch((error) => {
          const { error_description, error_code } =
            errorTypeHandler("NET_DISCONNECTED");

          errorHandler({
            error_code: error_code,

            message: error_description,
            severity: "warning",
          });
        });
    });
};
